import type { CartItemDTO } from "../api/types.js";

/** Merge duplicate product_id rows for display (cart draft may contain split lines). */
export function aggregateCartItems(items: CartItemDTO[]): CartItemDTO[] {
  const merged = new Map<string, CartItemDTO>();

  for (const item of items) {
    const existing = merged.get(item.product_id);
    if (!existing) {
      merged.set(item.product_id, { ...item });
      continue;
    }

    merged.set(item.product_id, {
      ...existing,
      qty: existing.qty + item.qty,
      line_total: existing.line_total + item.line_total,
      discount:
        existing.discount != null || item.discount != null
          ? (existing.discount ?? 0) + (item.discount ?? 0)
          : null,
    });
  }

  return Array.from(merged.values());
}
